import PropTypes from 'prop-types';
import React from 'react';
import StyledTypography from './styled-typography';

const propTypes = {
	children: PropTypes.node,
	color: PropTypes.string,
	dataTestId: PropTypes.string,
	size: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			xxs: PropTypes.string,
			xs: PropTypes.string,
			s: PropTypes.string,
			m: PropTypes.string,
			l: PropTypes.string,
			xl: PropTypes.string,
			xxl: PropTypes.string,
		}),
	]),
	tag: PropTypes.string,
	type: PropTypes.string,
};

const defaultProps = {
	children: undefined,
	color: undefined,
	dataTestId: null,
	size: '7',
	tag: undefined,
	type: 'heading',
};

function Typography({ children, dataTestId, tag, type, ...props }) {
	const defaultTags = {
		display: 'h1',
		heading: 'h1',
		paragraph: 'p',
	};

	return (
		<StyledTypography
			className="fuse-typography-element"
			data-testid={dataTestId}
			as={tag || defaultTags[type]}
			type={type}
			{...props}
		>
			{children}
		</StyledTypography>
	);
}

Typography.propTypes = propTypes;
Typography.defaultProps = defaultProps;

export default Typography;

export { Typography as TypographyComponent };
